import { render, staticRenderFns } from "./overlay.template.vue?vue&type=template&id=ac3411a4&scoped=true&"
var script = {}
import style0 from "./overlay.template.vue?vue&type=style&index=0&id=ac3411a4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac3411a4",
  null
  
)

export default component.exports